import { Download, Expand, Trash2 } from "lucide-react";
import type { TryOnJob } from "../lib/types";

interface HistoryPanelProps {
  jobs: TryOnJob[];
  onSelect: (job: TryOnJob) => void;
  onDelete: (id: string) => void;
  onClear: () => void;
  onDownload: (job: TryOnJob) => void;
  onPreview: (job: TryOnJob) => void;
}

export function HistoryPanel({ jobs, onSelect, onDelete, onClear, onDownload, onPreview }: HistoryPanelProps) {
  return (
    <section className="history-panel">
      <div className="panel-heading">
        <h2>本地历史</h2>
        <button className="text-button" type="button" onClick={onClear} disabled={jobs.length === 0}>
          <Trash2 size={16} />
          清空
        </button>
      </div>

      {jobs.length === 0 ? (
        <div className="empty-history">暂无结果</div>
      ) : (
        <div className="history-grid">
          {jobs.map((job) => (
            <article className="history-item" key={job.id}>
              <button
                className="history-thumb"
                type="button"
                onClick={() => {
                  onSelect(job);
                  if (job.resultImage) onPreview(job);
                }}
                aria-label={job.resultImage ? "放大查看历史结果" : "选择历史记录"}
              >
                {job.resultImage ? (
                  <img src={job.resultImage} alt="试戴结果" loading="lazy" />
                ) : (
                  <span>{job.status === "pending" ? "生成中" : "失败"}</span>
                )}
              </button>
              <div className="history-item-footer">
                <span>{formatDate(job.createdAt)}</span>
                <div className="icon-row">
                  <button
                    className="icon-button"
                    type="button"
                    onClick={() => onPreview(job)}
                    disabled={!job.resultImage}
                    aria-label="放大查看历史结果"
                    title="放大"
                  >
                    <Expand size={16} />
                  </button>
                  <button
                    className="icon-button"
                    type="button"
                    onClick={() => onDownload(job)}
                    disabled={!job.resultImage}
                    aria-label="下载历史结果"
                    title="下载"
                  >
                    <Download size={16} />
                  </button>
                  <button
                    className="icon-button danger"
                    type="button"
                    onClick={() => onDelete(job.id)}
                    aria-label="删除历史结果"
                    title="删除"
                  >
                    <Trash2 size={16} />
                  </button>
                </div>
              </div>
            </article>
          ))}
        </div>
      )}
    </section>
  );
}

function formatDate(value: string) {
  return new Intl.DateTimeFormat("zh-CN", {
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit"
  }).format(new Date(value));
}
